import React from 'react';
import { useMsal } from '@azure/msal-react';
import { ALLOWED_DOMAINS } from './authConfig';

export const DomainGuard = ({ children }) => {
  const { instance, accounts } = useMsal();

  if (accounts && accounts.length > 0) {
    const userEmail = accounts[0].username.toLowerCase();
    const userDomain = userEmail.split('@')[1];

    const isAuthorized = ALLOWED_DOMAINS.includes(userDomain);

    if (!isAuthorized) {
      return (
        <div style={{ display: 'flex', minHeight: '60vh', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
          <div className="login-card" role="alert" aria-live="polite" style={{ maxWidth: 720 }}>
            <h2 style={{ marginTop: 0 }}>Access Restricted</h2>
            <p style={{ color: 'var(--muted-light, #9fb6db)' }}>The account <strong>{userEmail}</strong> is not permitted to access this application.</p>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
              <button className="login-btn" onClick={() => instance.logoutRedirect()} aria-label="Sign in with a different account">Sign in with a different account</button>
            </div>
          </div>
        </div>
      );
    }
  }

  return children;
};

export default DomainGuard;
